var map = {
	"./best.svg": 9239,
	"./dream-pos.svg": 3595,
	"./dreamchat.svg": 5964,
	"./project-01.svg": 276,
	"./project-02.svg": 8135,
	"./project-03.svg": 8598,
	"./servbook.svg": 2002,
	"./sports.svg": 3632,
	"./truellysel.svg": 9806,
	"./truellysell.svg": 6550
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5905;